import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { HttpResponse, JobQueryParams, JobTrackerResponse } from "@/types";

export function useGetJobs(queryOptions?: JobQueryParams) {
  return useQuery({
    queryKey: ["jobs", queryOptions],
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams(queryOptions ?? {});

      const path = `jobs?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        JobTrackerResponse[],
        HttpResponse<JobTrackerResponse[]>
      >(path);
      return res.data;
    },
    //Don't allow a request to be made if there is no selected view
    enabled: !!queryOptions,
    // Keep previous data while fetching new results so the page doesn't unmount.
    placeholderData: (previousData) => previousData,
  });
}
